import { createReducer, on } from '@ngrx/store';
import { CustomStockProtectionOverviewList, SerialNoStatusResponseList } from '../custom-stock-potection.models';
import * as CustomStockProtectionActions from './custom-stock-protection.actions';

export const customStockProtectionFeatureKey = 'customStockProtection';

export const CUSTOM_STOCK_PROTECTION_OVERVIEW = 'customStockProtectionOverview';
export const CUSTOM_STOCK_PROTECTION_DETAILS = 'customStockProtectionDetails';

export interface CustomStockProtectionState {
    [CUSTOM_STOCK_PROTECTION_OVERVIEW]: {
      stockProtectionOverview: CustomStockProtectionOverviewList;
      isLoading: boolean;
      error?: Error;
    };
    [CUSTOM_STOCK_PROTECTION_DETAILS]: {
      stockProtectionDetails: SerialNoStatusResponseList;
      isLoading: boolean;
      error?: Error;
    };
}

export const initialState: CustomStockProtectionState = {
    [CUSTOM_STOCK_PROTECTION_OVERVIEW]: {
      stockProtectionOverview: null,
      isLoading: false,
      error: null,
    },
    [CUSTOM_STOCK_PROTECTION_DETAILS]: {
      stockProtectionDetails: null,
      isLoading: false,
      error: null,
    },
};

export const customStockProtectionReducer = createReducer(
    initialState,
    on(CustomStockProtectionActions.getStockProtectionOverview,
      (state) => ({
        ...state,
        [CUSTOM_STOCK_PROTECTION_OVERVIEW]: {
            stockProtectionOverview: null,
            isLoading: true,
            error: null,
        },
    })),
    on(CustomStockProtectionActions.getStockProtectionOverviewSuccess,
      (state, action) => ({
        ...state,
        [CUSTOM_STOCK_PROTECTION_OVERVIEW]: {
          stockProtectionOverview: action.stockProtectionOverview,
          isLoading: false,
          error: null,
        },
      })
    ),
    on(CustomStockProtectionActions.getStockProtectionOverviewFailure,
      (state, action) => ({
        ...state,
        [CUSTOM_STOCK_PROTECTION_OVERVIEW]: {
          stockProtectionOverview: null,
          isLoading: false,
          error: action.error,
        },
      })
    ),
    //******************************************************
    on(CustomStockProtectionActions.searchStockProtection,
      (state) => ({
        ...state,
        [CUSTOM_STOCK_PROTECTION_OVERVIEW]: {
            stockProtectionOverview: null,
            isLoading: true,
            error: null,
        },
    })),
    on(CustomStockProtectionActions.searchStockProtectionSuccess,
      (state, action) => ({
        ...state,
        [CUSTOM_STOCK_PROTECTION_OVERVIEW]: {
          stockProtectionOverview: action.stockProtectionOverview,
          isLoading: false,
          error: null,
        },
      })
    ),
    on(CustomStockProtectionActions.searchStockProtectionFailure,
      (state, action) => ({
        ...state,
        [CUSTOM_STOCK_PROTECTION_OVERVIEW]: {
          stockProtectionOverview: null,
          isLoading: false,
          error: action.error,
        },
      })
    ),
    //******************************************************
    on(CustomStockProtectionActions.clearStockProtectionOverview,
      (state) => ({
        ...state,
        [CUSTOM_STOCK_PROTECTION_OVERVIEW]: {
          stockProtectionOverview: null,
          isLoading: false,
          error: null,
        },
      })
    ),
    //******************************************************
    on(CustomStockProtectionActions.getStockProtectionDetails,
      (state) => ({
        ...state,
        [CUSTOM_STOCK_PROTECTION_DETAILS]: {
            stockProtectionDetails: null,
            isLoading: true,
            error: null,
        },
    })),
    on(CustomStockProtectionActions.getStockProtectionDetailsSuccess,
      (state, action) => ({
        ...state,
        [CUSTOM_STOCK_PROTECTION_DETAILS]: {
          stockProtectionDetails: action.stockProtectionDetails,
          isLoading: false,
          error: null,
        },
      })
    ),
    on(CustomStockProtectionActions.getStockProtectionDetailsFailure,
      (state, action) => ({
        ...state,
        [CUSTOM_STOCK_PROTECTION_DETAILS]: {
          stockProtectionDetails: null,
          isLoading: false,
          error: action.error,
        },
      })
    ),
    //******************************************************
    on(CustomStockProtectionActions.updateSerialNumbers,
      (state) => ({
        ...state,
        [CUSTOM_STOCK_PROTECTION_DETAILS]: {
            stockProtectionDetails: null,
            isLoading: true,
            error: null,
        },
    })),
    on(CustomStockProtectionActions.updateSerialNumbersSuccess,
      (state, action) => ({
        ...state,
        [CUSTOM_STOCK_PROTECTION_DETAILS]: {
          stockProtectionDetails: action.stockProtectionDetails,
          isLoading: false,
          error: null,
        },
      })
    ),
    on(CustomStockProtectionActions.updateSerialNumbersFailure,
      (state, action) => ({
        ...state,
        [CUSTOM_STOCK_PROTECTION_DETAILS]: {
          stockProtectionDetails: null,
          isLoading: false,
          error: action.error,
        },
      })
    ),
);